var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Kaiju Funds History")]),_c('ListFirestore',{attrs:{"item-name":"KaijuFundsHistoryItem","get-collection":_vm.getKaijuFundsHistory,"order-list":_vm.orderList},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var info = ref.item;
return [_c('KaijuFundsHistoryItem',{attrs:{"funds-info":info}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }